import React from 'react';
import { Check, Copy } from 'lucide-react';

export const COPIED_VISIBLE_MS = 2000;

// A copyable payment ID always says whose account it is: the provider and the owner's name sit
// above the ID, a visible Copy cue sits beside it, and a tap swaps the cue for a short Copied
// confirmation. The same field serves the review's receiving details and the hand-off chip.
export default function CopyField({ providerLabel, ownerName, value, display, copied, onCopy, chip = false }: {
  providerLabel: string;
  ownerName: string;
  value: string;
  display: string;
  copied: boolean;
  onCopy: (value: string, label: string) => void;
  chip?: boolean;
}) {
  return <div className={chip ? 'payment-v2-copy-field payment-v2-copy-field--chip' : 'payment-v2-copy-field'}>
    <span className="payment-v2-copy-owner">{providerLabel} — {ownerName}</span>
    <button type="button" className="payment-v2-copy" aria-label={`Copy ${display}`} data-copied={copied ? '' : undefined} onClick={() => onCopy(value, 'Receiving details')}>
      <strong>{display}</strong>
      {copied
        ? <span key="copied" className="payment-v2-copied" aria-hidden="true"><Check size={16} aria-hidden="true" /> Copied</span>
        : <span className="payment-v2-copy-cue" aria-hidden="true"><Copy size={16} aria-hidden="true" /> Copy</span>}
    </button>
  </div>;
}
